import _styled from "@emotion/styled/base";

function _EMOTION_STRINGIFIED_CSS_ERROR__() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }

export var List = /*#__PURE__*/_styled("ul", true ? {
  target: "e1gzlbhk0"
} : {
  target: "e1gzlbhk0",
  label: "List"
})(true ? {
  name: "9yyqsh",
  styles: "list-style-type:none;padding:24px 0;display:flex;gap:16px;flex-direction:column"
} : {
  name: "9yyqsh",
  styles: "list-style-type:none;padding:24px 0;display:flex;gap:16px;flex-direction:column",
  map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi93b3JrZGlyL2xpYnMvbWF0Y2hhL3JlY2lwZXMvTmF2aWdhdGlvbjIvRGVza3RvcE5hdmlnYXRpb24vTGlzdC9MaXN0LnZpZXdzLnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQUU2QiIsImZpbGUiOiIvd29ya2Rpci9saWJzL21hdGNoYS9yZWNpcGVzL05hdmlnYXRpb24yL0Rlc2t0b3BOYXZpZ2F0aW9uL0xpc3QvTGlzdC52aWV3cy50cyIsInNvdXJjZXNDb250ZW50IjpbImltcG9ydCBzdHlsZWQgZnJvbSAnQGVtb3Rpb24vc3R5bGVkJ1xuXG5leHBvcnQgY29uc3QgTGlzdCA9IHN0eWxlZC51bGBcbiAgbGlzdC1zdHlsZS10eXBlOiBub25lO1xuICBwYWRkaW5nOiAyNHB4IDA7XG4gIGRpc3BsYXk6IGZsZXg7XG4gIGdhcDogMTZweDtcbiAgZmxleC1kaXJlY3Rpb246IGNvbHVtbjtcbmBcbiJdfQ== */",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__
});